import * as React from 'react';
import {
    Stack,
    Typography,
} from '@mui/material';
import {
    TextInput,
    required,
} from 'react-admin';

export const ContractorOwnerInputs = () => {
    return (
        <Stack flex={1}>
            <ContractorOwnerBasicInputs />
        </Stack>
    );
};

const ContractorOwnerBasicInputs = () => {
    return (
        <Stack>
            <Typography variant="h6">Basic Info</Typography>
            <TextInput
                source="name"
                validate={required()}
                helperText={false}
            />
            <TextInput
                label="Last Name or Company Name"
                source="company_name"
                helperText={false}
            />
            <TextInput
                type="email"
                label="Email"
                source="email"
                helperText={false}
            />
            <TextInput
                type="tel"
                source="phone_number"
                helperText={false}
            />
        </Stack>
    );
};
